import { Component, OnInit, Inject } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'app-custom-snackbar-no-data',
  templateUrl: './custom-snackbar-no-data.component.html',
  styleUrls: ['./custom-snackbar-no-data.component.scss']
})
export class CustomSnackbarNoDataComponent implements OnInit {

  constructor(public snackBarRef: MatSnackBarRef<CustomSnackbarNoDataComponent>,
              @Inject(MAT_SNACK_BAR_DATA) public data: any) { }

  ngOnInit(): void {
  }

}
